<template>
	<div class="forget-wrapper">
		<div class="forget-container">
			<div class="forget-box">
				<div class="box-header">
					<div class="logo-wrapper">
						<img src="https://zhimaicoud.com/upload/common/default/ab59ade1101627b4d9bb9a589968c63e1760101014%5E%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250526105222_162.png"
							alt="至码云logo" class="logo" />
					</div>
					<h2 class="forget-title">重置密码</h2>
					<p class="subtitle">至码云API开放平台</p>
				</div>

				<el-form :model="userInfor" :rules="rules" ref="forgetForm" class="forget-form">
					<el-form-item prop="password">
						<el-input v-model="userInfor.password" placeholder="请输入新密码" type="password"
							prefix-icon="el-icon-lock" size="medium"></el-input>
					</el-form-item>

					<el-form-item prop="password_rep">
						<el-input v-model="userInfor.password_rep" placeholder="请确认新密码" type="password"
							prefix-icon="el-icon-lock" size="medium"></el-input>
					</el-form-item>

					<el-form-item prop="code">
						<div class="code-wrapper">
							<el-input v-model="userInfor.code" placeholder="请输入验证码" prefix-icon="el-icon-picture"
								size="medium"></el-input>
							<img :src="formatImageUrl(image_url) || 'https://picsum.photos/120/40'" alt="验证码"
								@click="change" class="code-img" :class="{ 'code-loading': isCodeLoading }" />
						</div>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" class="forget-button" @click="changePassword()" :loading="isLoading"
							size="medium">
							确认修改
						</el-button>
					</el-form-item>
				</el-form>

				<div class="extra-links">
					<router-link to="/login" class="back-link">返回登录</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			const validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.userInfor.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				userInfor: {
					password_rep: "",
					password: "",
					uuid: "",
					code: "",
				},
				image_url: "",
				isCodeLoading: false,
				isLoading: false,
				rules: {
					password: [{
							required: true,
							message: "请输入密码",
							trigger: "blur"
						},
						{
							min: 8,
							message: "密码长度不能少于8位",
							trigger: "blur"
						}
					],
					password_rep: [{
							required: true,
							message: "请确认密码",
							trigger: "blur"
						},
						{
							validator: validatePass,
							trigger: "blur"
						}
					],
					code: [{
						required: true,
						message: "请输入验证码",
						trigger: "blur"
					}]
				}
			};
		},
		methods: {
			formatImageUrl(url) {
				if (!url) return '';
				if (url.startsWith('data:image/') && url.includes('/jpg/png/gif;base64,')) {
					return url.replace('data:image/jpg/png/gif;base64,', 'data:image/png;base64,');
				}

				return url;
			},
			async getcode() {
				this.isCodeLoading = true;
				try {
					const res = await this.$api.getCaptcha.get();
					if (res.code == 200) {
						this.userInfor.uuid = res.data.uuid;
						this.image_url = res.data.image_url;
					}
				} catch (err) {
					console.error("验证码获取失败：", err);
					this.$message.error("验证码获取失败，请刷新重试");
					this.image_url = "https://picsum.photos/120/40";
				} finally {
					this.isCodeLoading = false;
				}
			},
			change() {
				this.getcode();
			},
			async changePassword() {
				try {
					await this.$refs.forgetForm.validate();
					this.isLoading = true;
					const res = await this.$api.login.forget(this.userInfor);
					console.log(res);
					if (res.code == 200) {
						this.$message.success("修改成功");
						this.$router.push("/login");
					} else {
						this.$message.error(res.msg || "修改失败");
					}
				} catch (error) {
					console.error('修改密码失败:', error);
					if (error !== false) {
						this.$message.error("修改失败，请重试");
					}
				} finally {
					this.isLoading = false;
				}
			},
		},
		created() {
			this.getcode();
		},
	};
</script>

<style lang="scss" scoped>
	.forget-wrapper {
		min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 50%, #fafbff 100%);
		padding: 20px;
	}

	.forget-container {
		width: 100%;
		max-width: 460px;
		animation: fadeInUp 0.6s ease-out;
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(30px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.forget-box {
		background: #ffffff;
		border-radius: 24px;
		box-shadow:
			0 20px 60px rgba(94, 96, 206, 0.12),
			0 8px 24px rgba(0, 0, 0, 0.06);
		padding: 50px 45px;
		border: 1px solid rgba(94, 96, 206, 0.06);

		.box-header {
			text-align: center;
			margin-bottom: 35px;

			.logo-wrapper {
				width: 80px;
				height: 80px;
				margin: 0 auto 20px;
				position: relative;
				overflow: hidden;
				border-radius: 16px;

				&::after {
					content: '';
					position: absolute;
					top: 0;
					left: -100%;
					width: 100%;
					height: 100%;
					background: linear-gradient(90deg,
							transparent,
							rgba(255, 255, 255, 0.6),
							transparent);
					animation: shimmer 2s infinite;
					pointer-events: none;
				}

				.logo {
					width: 100%;
					height: 100%;
					object-fit: contain;
					display: block;
				}
			}

			@keyframes shimmer {
				0% {
					left: -100%;
				}

				100% {
					left: 100%;
				}
			}

			.forget-title {
				font-size: 28px;
				font-weight: 700;
				color: #1a1a2e;
				margin: 0 0 8px 0;
			}

			.subtitle {
				font-size: 14px;
				color: #8a8aa3;
				margin: 0 0 16px 0;
			}
		}

		.forget-form {
			.el-form-item {
				margin-bottom: 22px;
			}

			::v-deep .el-input {
				.el-input__inner {
					height: 50px;
					border-radius: 14px;
					border: 2px solid #e8eaf2;
					transition: all 0.3s ease;
					font-size: 15px;
					padding-left: 45px;

					&:focus {
						border-color: #5e60ce;
						box-shadow: 0 0 0 4px rgba(94, 96, 206, 0.1);
					}

					&::placeholder {
						color: #b0b0c0;
					}
				}

				.el-input__prefix {
					left: 16px;
					color: #8a8aa3;
					font-size: 18px;
				}
			}

			.code-wrapper {
				display: flex;
				gap: 14px;

				.el-input {
					flex: 1;
				}

				.code-img {
					width: 130px;
					height: 50px;
					border-radius: 14px;
					cursor: pointer;
					transition: all 0.3s ease;
					border: 2px solid #e8eaf2;
					object-fit: cover;
					flex-shrink: 0;

					&:hover {
						transform: scale(1.03);
						border-color: #5e60ce;
					}

					&.code-loading {
						opacity: 0.6;
						filter: blur(2px);
					}
				}
			}

			.forget-button {
				width: 100%;
				height: 50px;
				background: linear-gradient(135deg, #5e60ce 0%, #7c7ff6 100%);
				border: none;
				border-radius: 14px;
				font-size: 16px;
				font-weight: 600;
				letter-spacing: 1px;
				transition: all 0.3s ease;

				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 10px 25px rgba(94, 96, 206, 0.4);
				}

				&:active {
					transform: translateY(0);
				}
			}
		}

		.extra-links {
			text-align: center;
			margin-top: 18px;

			.back-link {
				color: #8a8aa3;
				font-size: 14px;
				cursor: pointer;
				transition: all 0.3s ease;
				text-decoration: none;

				&:hover {
					color: #5e60ce;
				}
			}
		}
	}

	@media (max-width: 480px) {
		.forget-box {
			padding: 35px 25px;
			border-radius: 20px;

			.box-header {
				.logo {
					width: 65px;
					height: 65px;
				}

				.forget-title {
					font-size: 24px;
				}
			}

			.forget-form {
				.el-form-item {
					margin-bottom: 18px;
				}

				::v-deep .el-input .el-input__inner {
					height: 46px;
					font-size: 14px;
				}

				.code-wrapper .code-img {
					width: 110px;
					height: 46px;
				}

				.forget-button {
					height: 46px;
					font-size: 15px;
				}
			}
		}
	}
</style>